import calls from '@/backend/api-calls'

const state = () => ({
  workstations: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  },
  statuses: [
    'Active', 'On Break', 'Inactive', 'Down - Needs Repairs', 
    'Down - Being Repaired', 'Retired'
  ]
})

// getters
const getters = {
  ids: state => {
    return state.workstations.map(d => d.id);
  }
}

// actions
const actions = {
  getWorkstations: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.workstations.get(parameters)
        .then(resp => {
          commit("setWorkstations", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addWorkstation({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.workstations.post(data, parameters)
        .then(resp => {
          commit("insertWorkstation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Workstation successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addWorkstationWorkStep({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.workstationWorkSteps.post(data).then(
        resp => {
          commit("addWorkstationWorkStep", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteWorkstationWorkStep({commit}, { workstationId, workstationWorkStepId }) {
    return new Promise((resolve, reject) => {
      calls.workstationWorkStep.delete(workstationWorkStepId).then(
        resp => {
          commit("removeWorkstationWorkStep", 
            { workstationId, workstationWorkStepId }
          );
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateWorkstation: ({commit}, { workstationId, data }) => {
    return new Promise((resolve, reject) => {
      calls.workstation.put(workstationId, data).then(
        resp => {
          commit("insertUpdatedWorkstation", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Workstation successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteWorkstation: ({commit}, workstationId) => {
    return new Promise((resolve, reject) => {
      calls.workstation.delete(workstationId).then(
        resp => {
          commit("removeWorkstation", workstationId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Workstation successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setWorkstations(state, data) {
    state.pagination = data.pagination;
    state.workstations = data.results;
  },
  insertWorkstation(state, data) {
    state.workstations.push(data);
  },
  insertUpdatedWorkstation(state, data) {
    state.workstations.forEach((workstation, i) => {
      if (workstation.id == data.id) {
        state.workstations.splice(i, 1, data);
      }
    })
  },
  addWorkstationWorkStep(state, data) {
    state.workstations.forEach(workstation => {
      if (workstation.id == data.workstation_id) {
        workstation.workstation_steps.push(data);
      }
    })
  },
  removeWorkstationWorkStep(state, { workstationId, workstationWorkStepId }) {
    state.workstations.forEach(workstation => {
      if (workstation.id == workstationId) {
        workstation.workstation_steps.forEach((workStep, i) => {
          if (workStep.id == workstationWorkStepId) {
            workstation.workstation_steps.splice(i, 1);
          }
        })
      }
    })
  },
  removeWorkstation(state, workstationId) {
    state.workstations.forEach((workstation, i) => {
      if (workstation.id == workstationId) {
        state.workstations.splice(i, 1);
      }
      const index = state.selected.indexOf(workstationId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}